import Skeleton from "@mui/material/Skeleton";
import MuiAvatar from "@mui/material/Avatar";
import CloseIcon from "@mui/icons-material/Close";

import { Container } from "./styles";
import { stringAvatar } from "./controller";
import { AvatarProps } from "./types";

export function Avatar({
  src,
  name,
  size,
  isLoading,
  onRemove,
  shape = 'circular',
  fullWidth = false,
  ...avatarProps
}: AvatarProps) {
  return isLoading ? (
    <Skeleton variant="circular" width={size} height={size} />
  ) : (
    <Container>
      <MuiAvatar
        src={src}
        {...avatarProps}
        {...stringAvatar(fullWidth ? '100%' : size, name)}
        variant={shape === 'circular' ? 'circular' : 'rounded'}
      />

      {src && onRemove && (
        <button
          type="button"
          className="remove_button"
          onClick={onRemove}
          aria-label="Remover avatar"
        >
          <CloseIcon fontSize="small" />
        </button>
      )}
    </Container>
  );
}
